module.exports = __webpack_public_path__ + "img/name_long.7dbe3985.png";